import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-78299e97")

_pushScopeId("data-v-78299e97")
const _hoisted_1 = { style: {"text-align":"center","margin-bottom":"8px"} }
const _hoisted_2 = {
  key: 0,
  class: "selected"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/featured-icon.png"
}, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/featured-icon.png"
}, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "selected"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/leaderboard-icon.png"
}, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/leaderboard-icon.png"
}, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "selected"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/profile-icon.png"
}, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/profile-icon.png"
}, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "selected"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/settings-icon.png"
}, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/settings-icon.png"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")

  return (!_ctx.isWeb)
    ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_button, {
              class: "tab-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage('featured'))),
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                (_ctx.$route.name==='Featured')
                  ? (_openBlock(), _createBlock("div", _hoisted_2, [
                      _hoisted_3
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_4, [
                      _hoisted_5
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "tab-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage('leaderboard'))),
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                (_ctx.$route.name==='Leaderboard')
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _hoisted_7
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_8, [
                      _hoisted_9
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "tab-btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage('profile'))),
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                (_ctx.$route.name==='Profile')
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      _hoisted_11
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_12, [
                      _hoisted_13
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "tab-btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage('settings'))),
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                (_ctx.$route.name==='Settings')
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      _hoisted_15
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_16, [
                      _hoisted_17
                    ]))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
})